var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavNewChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pen-to-square-icon",
    clipPath: "url(#clip0_0_72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6601 2.74558L22.2544 3.33988C22.7161 3.80157 22.7161 4.54813 22.2544 5.00491L20.8251 6.4391L18.5609 4.17485L19.9902 2.74558C20.4519 2.28389 21.1984 2.28389 21.6552 2.74558H21.6601ZM10.3045 12.4361L16.8959 5.83988L19.1601 8.10412L12.5638 14.6955C12.4214 14.8379 12.2446 14.9411 12.053 14.9951L9.17976 15.8153L10 12.942C10.054 12.7505 10.1572 12.5737 10.2996 12.4312L10.3045 12.4361ZM18.3251 1.08055L8.63458 10.7662C8.20727 11.1935 7.89784 11.7191 7.73576 12.2937L6.33104 17.2053C6.21316 17.6179 6.32613 18.0599 6.63065 18.3644C6.93517 18.669 7.37721 18.7819 7.78978 18.664L12.7014 17.2593C13.2809 17.0923 13.8065 16.7829 14.2289 16.3605L23.9194 6.67485C25.2996 5.29469 25.2996 3.05501 23.9194 1.67485L23.3251 1.08055C21.945 -0.299607 19.7053 -0.299607 18.3251 1.08055ZM4.3222 2.99607C1.93517 2.99607 0 4.93124 0 7.31827V20.6778C0 23.0648 1.93517 25 4.3222 25H17.6817C20.0688 25 22.0039 23.0648 22.0039 20.6778V15.1768C22.0039 14.5236 21.4784 13.998 20.8251 13.998C20.1719 13.998 19.6464 14.5236 19.6464 15.1768V20.6778C19.6464 21.7633 18.7672 22.6424 17.6817 22.6424H4.3222C3.23674 22.6424 2.35756 21.7633 2.35756 20.6778V7.31827C2.35756 6.23281 3.23674 5.35363 4.3222 5.35363H9.82318C10.4764 5.35363 11.002 4.82809 11.002 4.17485C11.002 3.52161 10.4764 2.99607 9.82318 2.99607H4.3222Z",
    fill: "#850064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavNewChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nav-new-chat.53e7ad726dac655e45f9fd72e80d136b.svg";